export default "__VITE_ASSET__C7q0Jy0O__"